














import Vue from 'vue';

import BaseIcon from '../BaseIcon/BaseIcon.vue';

import {
  category as categoryPropDefinition,
  colorVariant,
} from '../../common/icon/props';
import { getIconIdentityClassName } from '../../common/icon/util';

/**
 * The Icon component is the Lightning Design System Icon component and should
 * be used for naked icons.
 *
 * For icons that are buttons, use the <a href='/components/buttons/'>Button component</a>
 * component with <code>variant='icon'</code>.
 */
export default Vue.extend({
  components: {
    BaseIcon,
  },
  inheritAttrs: false,

  props: {
    category: categoryPropDefinition,
    colorVariant,
    /**
     * CSS classes that are applied to the SVG.
     */
    svgClassName: {
      type: [String, Object, Array],
      default: undefined,
    },
    /**
     * Name of the icon. Visit <a href='http://www.lightningdesignsystem.com/resources/icons'>Lightning Design System Icons</a> to reference icon names.
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * Custom styles to be passed to the SVG. Could be used to change icon or background color.
     */
    svgStyle: {
      type: [String, Object, Array],
      default: undefined,
    },
    /**
     * Title attribute for the icon container
     */
    title: {
      type: String,
      default: undefined,
    },
    container: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    containerClassName(): Record<string, boolean> {
      const { category } = this;
      return {
        'slds-icon_container': category !== 'utility' || this.container,
        'slds-icon_container_circle': category === 'action',
        [this.kababCaseName]: category !== 'utility' && category !== 'doctype',
      };
    },
    computedColorVariant(): string | undefined {
      if (this.colorVariant) return this.colorVariant;
      return this.category === 'utility' ? 'default' : undefined;
    },
    kababCaseName(): string {
      return this.name
        ? getIconIdentityClassName(this.category, this.name)
        : '';
    },
  },
});
